import React from "react";

class CompanyDocumentsList extends React.Component {

    openFullSize(image) {
        switch (image) {
            case "Insurance":
                window.open("./companydocuments/insurance_full.jpg", "_blank");
                break;
            case "License":
                window.open("./companydocuments/license_full.jpg", "_blank");
                break;
            default:
                break;
        }
    }

    render() {
        switch (this.props.companydocuments) {
            case "en":
                this.selectedCompanyDocument = <div>
                    <div className="documents-wrapper">
                        <img className="documents-img" onClick={() => this.openFullSize('Insurance')} src="./companydocuments/thumb/insurance_thumb.jpg" alt="Insurance Certificate"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('License')} src="./companydocuments/thumb/license_thumb.jpg" alt="Company License"></img>
                    </div>
                </div >
                break;

            case "bg":
                this.selectedCompanyDocument = <div>
                    <div className="documents-wrapper">
                        <img className="documents-img" onClick={() => this.openFullSize('Insurance')} src="./companydocuments/thumb/insurance_thumb.jpg" alt="Insurance Certificate"></img>
                        <img className="documents-img" onClick={() => this.openFullSize('License')} src="./companydocuments/thumb/license_thumb.jpg" alt="Company License"></img>
                    </div>
                </div >
                break;

            default:
                break;
        }
        return this.selectedCompanyDocument;
    }
}

export default CompanyDocumentsList;